import { ArrowLeft } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { NeedsClusterRemovedDetailsDto, NeedsToBeMovedToStagingDetailsDto } from 'dtos'
import { OutboundTripNeedsDriversLicensePhotoUploadedPhotoProps } from './index'
import { NeedsDriversLicensePhotoUploadedDetailsDto } from 'dtos/needsDriversLicensePhotoUploadedDetailsDto'
import NeedsDriversLicensePhotoUploadedStepper from './NeedsDriversLicensePhotoUploadedStepper'
import CheckInReviewItem from 'pages/vehicles/id/checkIn/CheckInReviewItem'

interface Step2DriversLicensePhotoReviewProps extends OutboundTripNeedsDriversLicensePhotoUploadedPhotoProps {
  onBack: () => void
  onNext: () => void
  outboundTripNeedsDriversLicensePhotoUploadedDetails: NeedsDriversLicensePhotoUploadedDetailsDto
  outboundTripGuid?: string
}

export default function Step2DriversLicensePhotoReview({
  onBack,
  onNext,
  outboundTripNeedsDriversLicensePhotoUploadedDetails,
  outboundTripGuid,
  driversLicensePhoto,
  setDriversLicensePhoto
}: Step2DriversLicensePhotoReviewProps) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <NeedsDriversLicensePhotoUploadedStepper activeStep={1} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <CheckInReviewItem
            complete={Boolean(driversLicensePhoto.driversLicensePhotoFileName)}
            label='Drivers License Photo'
          />

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**To Do List Steps:**

Displays the current step of the for the To Do List in the Needs
Drivers License Uploaded Process.

**Drivers License Photo Check Mark:**

Displays a check mark to indicate that the Drivers Licenses
Photo has been successfully uploaded.

**SUBMIT Button:**

Clicking this button will:

Upload the Drivers License Photo and associate it with the
Outbound record, including:

- The name of the user who completed the process.

- A date/time stamp.

Return the user to the Needs Drivers License Uploaded to-do list
screen.

**PREVIOUS Button:**

Clicking this button will:

- Return the user to the previous step in the process.

`}
            </GreenText>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' fullWidth onClick={onNext} type='submit' variant='contained'>
              SUBMIT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
